import { api } from "./api";

export const gympassCheckIn = async (body: any): Promise<any> => {
  const { data } = await api.post("/gympass/confirm-check-in", body);
  return data;
};

export const gympassListCheckIn = async (): Promise<any> => {
  const { data } = await api.get("/gympass/check-ins");
  return data;
};

export const gympassListStudents = async (body: any): Promise<any> => {
  const { data } = await api.post("/gympass/confirm-check-in", body);
  return data;
};
